/**
 * Taking advantage of the useRef hook, we can access the latest state in a listener callback
 * Reference: https://medium.com/geographit/accessing-react-state-in-event-listeners-with-usestate-and-useref-hooks-8cceee73c559 and https://freedium.cfd/https://blog.stackademic.com/accessing-react-state-in-event-listeners-248af68c78da
 */

import { useRef, useState } from 'preact/hooks';

export const useStateAsRef = (initialState) => {
  const [myState, _setMyState] = useState(initialState);

  const myStateRef = useRef(myState);
  const setMyState = (data) => {
    // We both update the state and the ref
    myStateRef.current = data;
    _setMyState(data);
  };

  return [myStateRef, setMyState];
};
